import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import 'rxjs/add/observable/empty';

import {AutenticacaoService} from './autenticacao.service';

@Injectable()
export class RequisicaoInterceptorService implements HttpInterceptor {
  // todo Serviço de Loader

  private authService: AutenticacaoService;

  constructor(private injector: Injector) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.getAuthService().getToken();

    const req = request.clone(
      {setHeaders: {'x-access-token': token}}
    );

    return next
      .handle(req)
      .pipe(catchError((event) => {
        if (event instanceof HttpErrorResponse) {
          console.log(event.message);
          return this.catchError(event);
        }
      }));
  }

  getAuthService(): AutenticacaoService {
    if (typeof this.authService === 'undefined') {
      this.authService = this.injector.get(AutenticacaoService);
    }
    return this.authService;
  }

  catchError(error: HttpErrorResponse): Observable<any> {
    if (error.status === 401 || error.status === 404) {
      this.authService.logout();
      return Observable.empty();
    }
    return observableThrowError(error);
  }
}
